import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translations from './locales/translations.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // caches: [], // Uncomment this line for local testing and remove
    },
    resources: {
      en: {
        translation: translations['en'],
      },
      // es: { // TODO Uncomment this block when we're comfortable with our ES translations
      //   translation: translations['es'],
      // },
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
